export default __webpack_public_path__ + "static/media/recsys_gray.051263d1.svg";